export default "__VITE_ASSET__BP9$30Tz__";